<script setup>
import { parse } from 'js-html-parser';
import EditorJS from '@editorjs/editorjs';
import Table from '@editorjs/table';
import ImageTool from '@editorjs/image';
import Paragraph from '@editorjs/paragraph';
import Header from '@editorjs/header';
import List from "@editorjs/list";
import FavList from "@/components/edit/FavList.vue";
import TempList from "@/components/edit/TempList.vue";
import Releasedate from "@/components/common/ReleaseDate.vue"
import Gptform from "@/components/gpt/Gptform.vue";
import Gptwindow from "@/components/gpt/Gptwindow.vue";
import Analyzerelease from "@/components/release_create/AnalyzeRelease.vue";
import proinfo from "@/components/common/Productinfo.vue";
import Message from "@/components/common/Message.vue";
import moment  from "moment";
import FavBlock from "@/components/edit/FavBlock.vue";
import RelTemp  from "@/components/edit/RelTemp.vue";
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
    <v-card
        flat
        tile
        height="100%"
        max-width="800px"
    >
        <v-card-text
            class="py-1"
        >
    <v-expansion-panels
        v-model="isExpand"
        multiple
        class="mb-3"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="pb-2 px-3">
            <template v-slot:default="{ open }">
                <v-row no-gutters>
                    <v-col>
                        <h2 class="editor_h2">署名/商材情報</h2>
                    </v-col>
                    <v-col cols="1">
              <v-fade-transition leave-absolute>
                <span
                  v-if="open"
                  key="0"
                  class="hideui"
                >
                  隠す
                </span>
              </v-fade-transition>
                    </v-col>
                </v-row>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat>
            <v-card-text class="pb-5 pt-1">
                <b style="color:#616161"><v-icon color="#1976D2" small>mdi-information</v-icon>リリース作成に利用する様々なパラメータを設定します。一覧での管理にも利用します。</b>
            </v-card-text>
            <v-card-text>
            <v-row>
                <v-col cols="1" class="pl-3 pr-2 py-0">
                    <span class="cols_label">宛名</span>
                </v-col>
                <v-col class="px-2 py-0">
                    <span class="cols_data">{{ direction }}</span>
                </v-col>
                <v-col cols="1" class="px-2 py-0">
                    <span class="cols_label">署名</span>
                </v-col>
                <v-col  class="px-2 py-0">
                    <span class="cols_data" v-html="signature" />
                </v-col>
                <v-col cols="2">
                    <v-btn
                        dark
                        disable="gpt_use_flg"
                        @click="conf_open()"
                        color="#E13532"
                        class="mr-1"
                    >
                        <v-icon
                            left
                            dark
                        >
                            mdi-cog
                        </v-icon>
                        署名
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="py-0" cols="5">
                    <div style="width:250px;">
                        <v-select
                            v-model="therm"
                            :items="thermitem"
                            label="テーマ"
                            class="pt-2"
                            clearable
                            style="z-index: 102"
                        >
                        </v-select>
                    </div>
                </v-col>
                <v-col cols="1" class="px-2">
                    <span class="cols_label">商材名</span>
                </v-col>
                <v-col v-if="product == null">
                    <span class="cols_data">商材情報が設定されていません</span>
                </v-col>
                <v-col v-else>
                    <span class="cols_data">{{ product.product_name }}</span>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        dark
                        disable="gpt_use_flg"
                        @click="proinfo_open"
                        color="#E13532"
                        class="mr-1"
                    >
                        <v-icon
                            left
                            dark
                        >
                            mdi-cog
                        </v-icon>
                        商品
                    </v-btn>
                </v-col>
            </v-row>
            </v-card-text>
        </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="pb-2 px-3">
            <template v-slot:default="{ open }">
                <v-row no-gutters>
                    <v-col>
                        <h2 class="editor_h2">概要編集</h2>
                    </v-col>
                    <v-col cols="1">
              <v-fade-transition leave-absolute>
                <span
                  v-if="open"
                  key="0"
                  class="hideui"
                >
                  隠す
                </span>
              </v-fade-transition>
                    </v-col>
                </v-row>
            </template>

        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat>
            <v-card-text class="pb-5 pt-1">
                <b style="color:#616161"><v-icon color="#1976D2" small>mdi-information</v-icon>プレスリリースの概要部分の作成を行います。各機能はタイトルが必須項目になっています。</b>
            </v-card-text>
            <v-card-text class="py-1">
            <v-text-field
              clearable
              label="タイトル"
              placeholder="プレスリリースのタイトルを入力してください(最大100文字)"
              hide-details="auto"
              v-model="title"
              :value = "title"
              counter="100"
              outlined
              append-icon="mdi-content-copy"
              @click:append="copytitle"
            ></v-text-field>
            </v-card-text>
            <v-card-text class="pb-5 pt-1">
            <v-row>
            <v-col cols="5">
                    <v-menu
                        v-model="release_date_area"
                        :close-on-content-click="close_on"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        z-index="5000000"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                             v-model="release_date"
                             label="配信日"
                             prepend-icon="mdi-calendar"
                             readonly
                             v-bind="attrs"
                             v-on="on"
                           ></v-text-field>
                         </template>
                         <v-date-picker
                           v-model="release_date"
                           @input="release_date_area = false"
                           no-title
                           locale="jp-ja"
                           :day-format="(date) => new Date(date).getDate()"
                         ></v-date-picker>
                    </v-menu>
            </v-col>
            <v-col cols="3">
                    <v-select
                      v-model="release_time"
                      :items="timetable"
                      :disabled="time_disable"
                      style="z-index: 102"
                    ></v-select>
            </v-col>

            <v-col class="button_col">
                <v-btn
                    color="#E13533"
                    dark
                    :loading="sim_load"
                    @click="simOpen"
                    style="font-size:1.5rem;"
                >
                        配信候補日
                    <v-icon
                        right
                        dark
                    >
                        mdi-sim-outline
                    </v-icon>
                </v-btn>
            </v-col>
            </v-row>
            <v-text-field
              clearable
              label="サブタイトル"
              placeholder="サブタイトルを入力してください(最大100文字)"
              hide-details="auto"
              v-model="sub_title"
              :value = "sub_title"
              class="pt-3"
              counter="100"
              outlined
              append-icon="mdi-content-copy"
              @click:append="copysubtitle"
            ></v-text-field>
            <v-textarea
               clearable
               clear-icon="mdi-close-circle"
               label="概要説明"
               auto-grow
               v-model="summary"
               counter="500"
              outlined
              append-icon="mdi-content-copy"
              @click:append="copysummary"
             ></v-textarea>
            </v-card-text>
            </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header class="pb-2 px-3">
            <template v-slot:default="{ open }">
                <v-row no-gutters>
                    <v-col>
                        <h2 class="editor_h2">テンプレートを使う</h2>
                    </v-col>
                    <v-col cols="1">
              <v-fade-transition leave-absolute>
                <span
                  v-if="open"
                  key="0"
                  class="hideui"
                >
                  隠す
                </span>
              </v-fade-transition>
                    </v-col>
                </v-row>
            </template>

        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-card flat>
            <v-card-text class="pb-5 pt-1">
                <b style="color:#616161"><v-icon color="#1976D2" small>mdi-information</v-icon>プレスリリースのテンプレートを利用したり、現在の文書をテンプレートとして保存することができます</b>
            </v-card-text>
            <v-card-text class="py-1">
                <v-row>
                    <v-col style="display:flex;justify-content:center;">
                        <v-btn
                            color="#E13533"
                            dark
                            @click="rsave"
                        >
                            テンプレートを保存
                        </v-btn>
                    </v-col>
                    <v-col style="display:flex;justify-content:center;">
                        <v-btn
                            color="#E13533"
                            dark
                            @click="templistconfirm"
                        >
                            テンプレートを選ぶ
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
        </v-card-text>
        <v-card
            outlined
            style="width:850px;margin:auto;"
            min-height="100vh"
        >
        <v-toolbar
            flat
            tile
            height="50px"
        >
            <span class="bar_mess">※ブロック毎に編集することができます。ブロック内で改行したい場合はShift+Returnで改行できます。</span>
            <v-spacer />
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-on="on"
                    v-bind="attrs"
                    class="ml-2"
					@click="copysentences"
                >
                    mdi-content-copy
                </v-icon>
                </template>
                <span>コピー</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-on="on"
                    v-bind="attrs"
                    class="ml-2"
                    @click="sentence_delete"
                >
                    mdi-delete
                </v-icon>
                </template>
                <span>削除</span>
            </v-tooltip>
        </v-toolbar>
        <div class="editor">
            <div class="tool_area" />
            <div id="editorjs"></div>
        </div>
        </v-card>
    <Releasedate
        ref="sim"
        :relconfirm = "relconfirm"
        v-on:select-release="showRelease($event)"
        v-on:relclose="relclose_status($event)"
        v-on:opened="sim_load=false"
    >
    </Releasedate>
    <FavBlock 
        ref="fav"
        :favtext="favtext"
        v-on:updated="favupdate($event)"
     />
    <RelTemp
        ref="rtemp"
        :template_id="template_id"
     />
    <Message
        ref="mess"
        :message="alertmess"
        :title="alerttitle"
        v-on:messreturn="dummy_func"
    />
    <proinfo
        ref="pi"
        v-on:setproduct="setpro($event)"
    >
    </proinfo>
    <FavList ref="favlist" :list="favlist" v-on:selected="setfavblock($event)" />
    <TempList ref="templist" />
    <Gptform
        ref="gpt"
        :conf_id="set_conf_id"
        v-on:conflist="conf_open"
    >
    </Gptform>
    <Analyzerelease
        ref="anal"
        v-on:configload="config_loaded()"
        :conf_id="set_conf_id"
    >
    </Analyzerelease>
    <Gptwindow
        ref="gptw"
        v-on:paragraph="insertAI($event)"
    >
    </Gptwindow>
    </v-card>
</template>
<script>
export default {
  computed : {
        update_block : function(){
            return this.$store.getters['update_block/get_update'];
        },
        update_id : function(){
            return this.$store.getters['update_block/get_update_id'];
        },
        product_list : function(){
            return this.$store.getters['product_list/get_product'];
        },
        set_conf_id : function(){
            return this.$store.getters['doc_info/get_conf_id'];
        },
        doc_id : function(){
            return this.$store.getters['doc_info/get_doc_id'];
        },
        product_id : function(){
            return this.$store.getters['doc_info/get_product_id'];
        },
        direction : function() {
             return this.$store.getters['doc_info/get_direction'];
        },
        status : function() {
             return this.$store.getters['doc_info/get_status'];
        },
        signature : function() {
             return this.$store.getters['doc_info/get_signature'];
        },
        ai_doc : function() {
             return this.$store.getters['doc_info/get_ai_doc'];
        },
        therm : {
            get(){
                return this.$store.getters['doc_info/get_therm'];
            },
            set(val){
                let set_val = "";
                if(val != null)
                    set_val = val;
                this.$store.commit("doc_info/set_therm",set_val);
            }
        },
    },

    data () {
      return {
        favlist  : [],
        alertmess : "",
        alerttitle : "",
        messfunc   : null,
        tool_black : ['stretched','withBorder','withBackground',],
        favtext  : "",
        isExpand : [0,1,2],
        gpt_use_flg : true,
        isready   : false,
        editor: null,
        editor_index : 0,
        editdata  : "",
        template_id : "",
        title     : "",
        sub_title : "",
        summary   : "",
        t_doc     : "",
        e_doc     : "",
        product   : null,
        timeout   : null,
        etimeout   : null,
        close_on : false,
        release_date :"",
        release_time:"",
        release_date_area : false,
        relconfirm : false,
        sim_load   : false,
        timetable : [],
        time_disable  : false,
        init_flg   : false,
        reserv_status : false,
        thermitem : ["イベント","新商品","キャンペーン","リニューアル","機能追加","セミナー","お知らせ","その他"],
      }
    },
    watch : {
        update_id : function(){
            this.update_block_data();
        },
        title : function(){
            this.docsync();
        },
        sub_title : function(){
            this.docsync();
        },
        release_date : function(){
            this.docsync();
        },
        release_time : function(){
            this.docsync();
        },
        summary  : function(){
            this.docsync();
        },
        e_doc : function(){
            this.docsync();
        },
        t_doc :function(){
            this.docsync();
        },
        editdata : function(){
            this.reserv_status = true;
            clearTimeout(this.etimeout);
            this.etimeout = setTimeout(() => {
                this.object2HTML();
                this.$store.commit("doc_info/set_editdata",this.editdata);
            }, 500);
        },
        reserv_status : function(){
            if(this.reserv_status == false)
            {
                this.$emit("reservable");
            }
        },
        ai_doc : function(){
            //this.e_doc=this.ai_doc;
            this.$emit("ai_reload");
        },
        ai_title : function(){
            this.title=this.ai_title;
        },
        ai_sub_title : function(){
            this.sub_title=this.ai_sub_title;
        },
        ai_summary : function(){
            this.summary=this.ai_summary;
        },
        isready : function(){
            this.editor.save().then((outputData) => {
                this.editdata = outputData;
            }).catch((error) => {
                console.log('Saving failed: ', error)
            });
            //this.getdoc();
            this.init_flg=true;
            this.$nextTick(
                this.editor_menu_gen()
            );
        },
        product_list : function(){
            this.product_set();
        },
    },

    methods: {
        dummy_func : function(){
            if(this.messfunc != null)
                this.messfunc();
        },
        templistconfirm : function(){
            if(this.editdata.blocks.length==1 && this.editdata.blocks[0].type=="paragraph" && this.editdata.blocks[0].data.text=="")
            {
                this.tempopen();
            }
            else
            {
                this.alerttitle = "入力中の文章と入れ替えます。よろしいですか？";
                this.alertmess  = "文章をそのまま利用したい場合はいいえを押下してください。";
                this.messfunc = this.tempopen;
                this.$refs.mess.opendl();
            }
        },
        tempopen    : function(){
            this.$refs.templist.open();
        },
        rsave       : function(){
            this.$refs.rtemp.open();
        },
        favupdate   : function(data){
            this.favlist = data;
        },
        reserv_sent : function(){
            return this.reserv_status;
        },
        update_block_data : async function(){

            let index = -1;
            for(let cnt = 0 ; cnt < this.editdata.blocks.length ; cnt++)
            {
                if(this.update_id == this.editdata.blocks[cnt].id)
                {
                    index = cnt;
                    break;
                }
            }
            this.editor.caret.setToBlock(index);
            let blockcnt = 0;
            for(blockcnt = 0 ; blockcnt < this.update_block.blocks.length ; blockcnt++)
            {
                this.editor.blocks.insert(this.update_block.blocks[blockcnt].type,this.update_block.blocks[blockcnt].data,undefined,index+blockcnt,undefined,false);
            }
            this.editor.blocks.delete(index+blockcnt);

            /* コメント付け替え用 */
            let newblock = this.editor.blocks.getBlockByIndex(index);
            this.$emit("blockupdated",{new_id:newblock.id,old_id:this.update_id});

        },
        setfavblock     : function(data)
        {
            let blocks = this.editor.blocks.getBlockByIndex(this.editor_index);
            if(blocks.isEmpty==true)
                this.editor_index -= 1;
            this.editor.caret.setToBlock(this.editor_index);
            this.editor.blocks.insert(
                data.type,
                data.data
            );
        },
        proinfo_open    : function(){
            this.$refs.pi.selected_open(this.product_id);
        },
        product_set : function(){
            let ret_pro = null;
            for(let cnt = 0 ; cnt < this.product_list.length ; cnt++)
            {
                if(this.product_list[cnt].id == this.product_id)
                {
                    ret_pro = this.product_list[cnt];
                    break;
                }
            }
            this.product = ret_pro;
        },
        setpro     : function(data){
            this.$store.commit("doc_info/set_product_id",data.id);
            this.product_set();
        },
        docsync : function(){
            if(this.init_flg == false)
            {
                return;
            }
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.syncdata();
            }, 500);
        },
        syncdata : function(){
            let release_date = "";
            if(this.release_date != "")
            {
                release_date = this.release_date;
                if(this.release_time != "")
                {
                    release_date += " "+this.release_time
                }
            }
            this.$store.commit("doc_info/set_doc",{
                "title"     : this.title,
                "sub_title" : this.sub_title,
                "release_date" : release_date,
                "summary"   : this.summary,
                "doc"    : this.e_doc,
            });
            this.reserv_status = false;
        },
        HTMLparser : function(){
            const doc = parse(this.e_doc);
            let objarry = [];
            for(let cnt = 0 ; doc.childNodes.length > cnt ; cnt++)
            {
                let id = "";
                if(doc.childNodes[cnt].nodeType==1 && doc.childNodes[cnt].tagName=='p')
                {
                    let json = {};
                    if(doc.childNodes[cnt].childNodes.length==0)
                    {
                        continue;
                    }
                    if(doc.childNodes[cnt].id != undefined && doc.childNodes[cnt].id!="" && doc.childNodes[cnt].id != "''")
                    {
                        id=doc.childNodes[cnt].id;
                    }
                    else
                    {
                        id='datablock-' + cnt;
                    }
                    
                    if(doc.childNodes[cnt].childNodes[0].tagName == 'STRONG' || doc.childNodes[cnt].childNodes[0].tagName == 'strong')
                    {
                        json = { type : "header",data : {text : doc.childNodes[cnt].childNodes[0].innerHTML},id:id};
                        objarry.push(json);
                    }
                    else if(doc.childNodes[cnt].childNodes[0].tagName == 'img')
                    {
                        let src = "";
                        let caption = "";
                        for(let i = 0 ; i < doc.childNodes[cnt].childNodes.length ; i++)
                        {
                            if(doc.childNodes[cnt].childNodes[i].tagName == 'img')
                            {
                                src = doc.childNodes[cnt].childNodes[i].attributes.src;
                            }
                            else if(doc.childNodes[cnt].childNodes[i].tagName == 'span')
                            {
                                caption = doc.childNodes[cnt].childNodes[i].innerHTML;
                            }
                        }
                        json = {type : "image",data : {file : {url : src},caption:caption},id:id};
                        objarry.push(json);
                    }
                    else if(doc.childNodes[cnt].childNodes[0].tagName == 'table')
                    {
                        let tablelem = doc.childNodes[cnt].childNodes[0];
                        let tr_array = [];
                        let header_flg = false;
                        for(let i = 0 ; i < tablelem.childNodes.length ; i++)
                        {
                            let td_array = [];
                            let trelem  = tablelem.childNodes[i];
                            for( let j = 0 ; j < trelem.childNodes.length ; j++)
                            {
                                if(trelem.childNodes[j].tagName == 'th')
                                {
                                    header_flg = true;
                                }
                                td_array.push(trelem.childNodes[j].innerHTML);
                            }
                            tr_array.push(td_array);
                        }
                        json = {
                            type : "table",
                            data : {
                                withHeadings: header_flg,
                                content : tr_array,
                            }
                            ,id:id
                        };
                        objarry.push(json);
                    }
                    else if(doc.childNodes[cnt].childNodes[0].tagName == 'ul' || doc.childNodes[cnt].childNodes[0].tagName =='ol')
                    {
                        let style="";
                        if(doc.childNodes[cnt].childNodes[0].tagName == 'ul')
                        {
                            style="unordered";
                        }
                        else
                        {
                            style="ordered";
                        }
                        let items = [];
                        let elements = doc.childNodes[cnt].childNodes[0].childNodes;
                        for( let i = 0 ; i <  elements.length; i++)
                        {
                            items.push(elements[i].innerHTML);
                        }
                        json = {type : "list" , data : {
                                style:style,
                                items :items,
                            }
                            ,id:id
                        };
                        objarry.push(json);
                    }
                    else
                    {
                        json = {
                        type : "paragraph",
                            data : {
                                text:doc.childNodes[cnt].innerHTML,
                            }
                            ,id:id
                        };
                        objarry.push(json);
                    }
                }
            }
            return objarry;
        },
        dataMigration : function(){
            const parser = new DOMParser();
            this.HTMLparser();
            const doc = parser.parseFromString(this.e_doc, 'text/html');
            let elements = doc.body.children;
            for(let cnt = 0 ; cnt < elements.length ; cnt++)
            {
                if(elements[cnt].childElementCount && elements[cnt].tagName == 'P')
                {
                    if(elements[cnt].firstElementChild.tagName == 'STRONG')
                    {
                        this.editor.blocks.insert(
                            "header",
                            {
                                text:elements[cnt].firstElementChild.innerHTML,
                            },
                        );
                    }
                    else if(elements[cnt].firstElementChild.tagName == 'IMG')
                    {
                        let src = "";
                        let caption = "";
                        for(let i = 0 ; i < elements[cnt].childElementCount ; i++)
                        {
                            if(elements[cnt].children[i].tagName == 'IMG')
                            {
                                src = elements[cnt].children[i].src;
                            }
                            else if(elements[cnt].children[i].tagName == 'SPAN')
                            {
                                caption = elements[cnt].children[i].innerHTML;
                            }
                        }
                        // 仮にイメージを入れる
                        this.editor.blocks.insert(
                            "image",
                            {
                                file:{ url : src },
                                caption : caption,
                            },
                        );
                    }
                    else if(elements[cnt].firstElementChild.tagName == 'TABLE')
                    {
                        let tablelem = elements[cnt].firstElementChild;
                        if(elements[cnt].firstElementChild.firstElementChild.tagName == 'TBODY')
                            tablelem = elements[cnt].firstElementChild.firstElementChild;
                        let tr_array = [];
                        let header_flg = false;
                        for(let i = 0 ; i < tablelem.childElementCount ; i++)
                        {
                            let td_array = [];
                            let trelem  = tablelem.children[i];
                            for( let j = 0 ; j < trelem.childElementCount ; j++)
                            {
                                if(trelem.children[j].tagName == 'TH')
                                {
                                    header_flg = true;
                                }
                                td_array.push(trelem.children[j].innerHTML);
                            }
                            tr_array.push(td_array);
                        }
                        this.editor.blocks.insert(
                            "table",
                            {
                                withHeadings: header_flg,
                                content : tr_array,
                            },
                        );
                    }
                }
                else if(elements[cnt].childElementCount && (elements[cnt].tagName == 'UL' || elements[cnt].tagName =='OL'))
                {
                    let style="";
                    if(elements[cnt].tagName == 'UL')
                    {
                        style="unordered";
                    }
                    else
                    {
                        style="ordered";
                    }
                    let items = [];
                    for( let i = 0 ; i < elements[cnt].childElementCount ; i++)
                    {
                        items.push(elements[cnt].children[i].innerHTML);
                    }
                    this.editor.blocks.insert(
                        "list",
                        {
                            style:style,
                            items :items, 
                        },
                    );
                }
                else
                {
                    this.editor.blocks.insert(
                        "paragraph",
                        {
                            text:elements[cnt].innerHTML,
                        },
                    );
                }
            }
          },
          object2HTML : function(){
               let htmlText = "";
               for(let cnt = 0 ; cnt < this.editdata.blocks.length ; cnt++)
               {
                    htmlText += "<p id='"+this.editdata.blocks[cnt].id+"'>"
                    if(this.editdata.blocks[cnt].type == "paragraph")
                    {
                         htmlText += this.editdata.blocks[cnt].data.text;
                    }
                    else if(this.editdata.blocks[cnt].type == "header")
                    {
                         htmlText += "<STRONG>";
                         htmlText += this.editdata.blocks[cnt].data.text;
                         htmlText += "</STRONG>";
                    }
                    else if(this.editdata.blocks[cnt].type == "table")
                    {
                        if(this.editdata.blocks[cnt].data.content.length == 0)
                        {
                            htmlText += "</p>";
                            continue;
                        }
                         htmlText += "<table>";
                         let header_flg = this.editdata.blocks[cnt].data.withHeadings;
                         for(let ccnt = 0 ; this.editdata.blocks[cnt].data.content.length > ccnt ; ccnt++)
                         {
                              htmlText += "<tr>";
                              for(let cccnt = 0 ; this.editdata.blocks[cnt].data.content[ccnt].length > cccnt ; cccnt++)
                              {
                                   if(ccnt == 0 && header_flg)
                                   {
                                        htmlText += "<th>";
                                   }
                                   else
                                   {
                                        htmlText += "<td>";
                                   }
                                   htmlText += this.editdata.blocks[cnt].data.content[ccnt][cccnt];
                                   if(ccnt == 0 && header_flg)
                                   {
                                        htmlText += "</th>";
                                   }
                                   else
                                   {
                                        htmlText += "</td>";
                                   }
                              }
                              htmlText += "</tr>";
                         }
                         htmlText += "</table>";
                    }
                    else if(this.editdata.blocks[cnt].type == "list")
                    {
                        if(this.editdata.blocks[cnt].data.style=="unordered")
                        {
                             htmlText += "<ul>";
                        }
                        else
                        {
                             htmlText += "<ol>";
                        }
                        for(let ccnt = 0 ; this.editdata.blocks[cnt].data.items.length > ccnt ; ccnt++)
                        {
                             htmlText += "<li>" + this.editdata.blocks[cnt].data.items[ccnt] + "</li>";
                        }
                        if(this.editdata.blocks[cnt].data.style=="unordered")
                        {
                             htmlText += "</ul>";
                        }
                        else
                        {
                             htmlText += "</ol>";
                        }
                    }
                    else if(this.editdata.blocks[cnt].type == "image")
                    {
                        htmlText += "<img src='"+this.editdata.blocks[cnt].data.file.url+"'>";
                        if(this.editdata.blocks[cnt].data.caption != "")
                        {
                            htmlText += "<span class=\"imgcaption\">" +this.editdata.blocks[cnt].data.caption+ "</span>";
                        }
                    }
                    htmlText += "</p>\n"
                }
                this.e_doc = htmlText;
                //this.HTMLparser();
          },
        getdoc : function()
        {
            this.title =   this.$store.getters['doc_info/get_title'];
            this.sub_title = this.$store.getters['doc_info/get_subtitle'];
            this.summary = this.$store.getters['doc_info/get_summary'];
            let release_date = this.$store.getters['doc_info/get_release_date'];
            if(release_date != "" && release_date != null)
            {
                this.release_date = moment(release_date).format("YYYY-MM-DD");
                this.release_time = moment(release_date).format("HH:mm");
            }
            this.e_doc = this.$store.getters['doc_info/get_doc'];
            /*
            if(this.$store.getters['doc_info/get_migration'] == false)
            {
                this.dataMigration();
            }
            */
            this.product_set();
            this.gpt_use_flg=false;
        },
        sentence_delete   : function(){
            if(window.confirm("本文を削除します。よろしいですか？") == true)
            {
                this.editor.clear();
            }
        },
        insertAI : async function(data){
            let blocks = this.editor.blocks.getBlockByIndex(this.editor_index);
            if(blocks.isEmpty==true)
                this.editor_index -= 1;
            this.editor.caret.setToBlock(this.editor_index);
            this.editor.blocks.insert(
                "header",
                {
                    text:data.headline,
                },
            );
            this.editor.blocks.insert(
                "paragraph",
                {
                    text:data.paragraph,
                },
            );
            this.editor_index = this.editor.blocks.getCurrentBlockIndex();

        },
        insertIMG : function(data){
            let blocks = this.editor.blocks.getBlockByIndex(this.editor_index);
            if(blocks.isEmpty==true)
                this.editor_index -= 1;
            this.editor.caret.setToBlock(this.editor_index);
            this.editor.blocks.insert(
                "image" ,
                {
                    file : { url:"https://search.qlipper.jp/cont/dsp?id=" + data}
                },
            );
            this.editor_index = this.editor.blocks.getCurrentBlockIndex();
        },
        gpt_move    : function(){
            this.$refs.gpt.move();
        },
        showRelease : function(data){
            this.release_date = moment(data.date).format("YYYY-MM-DD");
            this.release_time = moment(data.date).format("HH:mm");
            this.$refs.sim.simClose();
        },
        simOpen  : function(){
            this.sim_load=true;
            this.$refs.sim.simOpen();
        },
        copy        : function(data){
            navigator.clipboard.writeText(data);
        },
        copytitle    : function(){
            this.copy(this.title);
        },
        copysubtitle : function(){
            this.copy(this.sub_title);
        },
        copysummary  : function(){
            this.copy(this.summary);
        },
		copysentences : function(){
			let output = "";
			for(let i = 0 ; i < this.editdata.blocks.length ; i++)
			{
				let block = this.editdata.blocks[i];
				if(block.type=="image")
				{
					output += "===========ここに画像を入れる=========\n";
					if(block.data.caption != "")
						output += block.data.caption + "\n";
				}
				else if(block.type=="header")
				{
					output += "\n"+block.data.text+"\n";
				}
				else if(block.type=="paragraph")
				{
					output += block.data.text+"\n";
				}
				else if(block.type=="list")
				{
					for(let ii = 0 ; ii < block.data.items.length ; ii++)
					{
						let ordered = "・";
						if(block.data.style !="unordered")
						{
							ordered = ii+1 + ".";	
						}
						output += ordered + block.data.items[ii] + "\n";
					}
				}
				else if(block.type=="table")
				{
					for(let ii = 0 ; ii < block.data.content.length ; ii++)
					{
						for(let j = 0 ; j < block.data.content[ii].length ; j++)
						{
							if(j != 0)
								output += "\t";
							output += block.data.content[ii][j];
						}
						output += "\n";
					}
				}
			}
            this.copy(output);
		},
        conf_open   : function(){
            this.$refs.anal.config();
        },
        config_loaded : function(){
            this.config_loaded_flg=true;
        },
        paragraph : function(){
            this.editor_index = this.editor.blocks.getCurrentBlockIndex();
            this.$refs.gptw.open();
        },
        favlist_open : function(){
            this.editor_index = this.editor.blocks.getCurrentBlockIndex();
            this.$refs.favlist.open();
        },
        editor_menu_gen : function(){
            let editorelem = document.getElementById("editorjs");

            var mo = new MutationObserver(this.dom_editor);
            const options = {
                childList: true,
                characterData: true,
                characterDataOldValue: true,
                attributes: true,
                subtree: true,
            }

            mo.observe(editorelem, options);

            let elem = document.querySelector(".ce-popover__items");
            let menuTag = document.createElement('div');
            menuTag.className = "ce-popover-item";
            menuTag.innerHTML = '<div class="ce-popover-item__icon"><img src="./format-paragraph.svg"></div><div class="ce-popover-item__title">AIで作る</div>';
            menuTag.addEventListener('click',this.paragraph,false);
            elem.appendChild(menuTag);
            menuTag = document.createElement('div');
            menuTag.className = "ce-popover-item";
            menuTag.innerHTML = '<div class="ce-popover-item__icon"><img src="./image-outline.svg"></div><div class="ce-popover-item__title">ギャラリーから追加</div>';
            menuTag.addEventListener('click',this.garally,false);
            elem.appendChild(menuTag);
            menuTag = document.createElement('div');
            menuTag.className = "ce-popover-item";
            menuTag.innerHTML = '<div class="ce-popover-item__icon"><img src="./star.svg"></div><div class="ce-popover-item__title">お気に入り段落</div>';
            menuTag.addEventListener('click',this.favlist_open,false);
            elem.appendChild(menuTag);

        },
        dom_editor : function(){
            for(let cnt = 0 ; cnt < this.tool_black.length ; cnt++)
            {
                let elem = document.querySelectorAll('div[data-item-name="'+this.tool_black[cnt]+'"]');
                if(elem.length == 0)
                    continue;
                elem[0].remove();
            }
            let elem = document.querySelector(".cdx-search-field");
            if(elem != null)
                elem.remove();
            elem = document.querySelector(".ce-settings");

            if(elem == null)
                return;
            if(elem.querySelector("#fav") != null)
                return;

            let list = elem.querySelector(".ce-popover__items");
            if(list == null)
                return;
            // お気に入りメニュー追加
            let menuTag = document.createElement('div');
            menuTag.className = "ce-popover-item";
            menuTag.innerHTML = '<div class="ce-popover-item__icon"><img src="./star.svg"></div><div class="ce-popover-item__title" id="fav">お気に入り</div>';
            menuTag.addEventListener('click',this.favorite,false);
            list.appendChild(menuTag);
        },
        favorite : async function()
        {
            const current_block = this.editdata.blocks[this.editor.blocks.getCurrentBlockIndex()];
            let json_text = current_block;
            if(current_block == undefined)
            {
                return;
            }
            this.$refs.fav.open(json_text);
        },
        garally : function()
        {
            this.editor_index = this.editor.blocks.getCurrentBlockIndex();
            this.$emit("garally");
        },
    },
    created : function(){
        this.getdoc();
    },
    mounted : function(){
        let savedata = this.HTMLparser();
        this.editor = new EditorJS({
          placeholder: 'ここにプレスリリースの本文を入力してください。',
          data: {
            blocks: savedata,
          },
          tools: {
            header: {
                class :Header,
                config: {
                  placeholder: "ヘッダー",
                  levels: [2,],
                  defaultLevel: 2
                },
                inlineToolbar: false,
            },
            list: {
              class: List,
              inlineToolbar: true,
              config: {
                defaultStyle: 'unordered'
              }
            },
          image: {
            class: ImageTool,
            config: {
              actions: [],
              uploader: {
                uploadByFile(file) {
                  let formData = new FormData()
                  formData.append('image', file)
                  let config = {headers: {'content-type': 'multipart/form-data'}}
                  return axios.post('https://search.qlipper.jp/cont/', formData, config)
                    .then(res => {
                      return res.data
                    })
                },
                //only work when url has extensions like .jpg
                /*
                uploadByUrl(url) {
                  return axios.post('api/blog/fetch_file', {url: url}).then(res => {
                    return res.data
                  })
                }
                */
                uploadByUrl(url) {
                  return new Promise((resolve) => {
                      resolve({ success: 1, file: { url: url } });
                  });
                },
              }
            }
          },

           paragraph: {
                class: Paragraph,
                inlineToolbar: true,
                config: {
                    // 空の行を許可する。
                    preserveBlank: true,
                },
            },
            table: Table,
          },
          i18n: {
            messages: {
              ui: {
                "blockTunes": {
                  "toggler": {
                    "Click to tune": "調整メニュー",
                    "or drag to move": "ドラックして移動"
                  },
                },
                "inlineToolbar": {
                  "converter": {
                    "Convert to": "ブロック種類の変更"
                  }
                },
                "toolbar": {
                  "toolbox": {
                    "Add": "追加"
                  }
                }
              },
              toolNames: {
                "Text": "テキスト",
                "Heading": "見出し",
                "List": "リスト",
                "Image": "画像挿入",
                "Table": "表の挿入",
                //"Link": "リンク",
                //"Marker": "Маркер",
                "Bold": "太字",
                "Italic": "斜体",
                "InlineCode": "コード",
              },
        "tools": {
          /**
           * Each subsection is the i18n dictionary that will be passed to the corresponded plugin
           * The name of a plugin should be equal the name you specify in the 'tool' section for that plugin
           */
          "warning": { // <-- 'Warning' tool will accept this dictionary section
            "Title": "Название",
            "Message": "Сообщение",
          },

          /**
           * Link is the internal Inline Tool
           */
          "link": {
            "Add a link": "リンクを追加する"
          },
          /**
           * The "stub" is an internal block tool, used to fit blocks that does not have the corresponded plugin
           */
          "stub": {
            'The block can not be displayed correctly.': 'ブロックが正しく表示できませんでした'
          },
          "image": {
            "Caption": "画像の見出し",
            "Select an Image": "画像を選択してください",
            "With border": "枠線をつける",
            "Stretch image": "画像を引き伸ばす",
            "With background": "背景をつける",
          },
          "code": {
            "Enter a code": "Код",
          },
          "linkTool": {
            "Link": "Ссылка",
            "Couldn't fetch the link data": "Не удалось получить данные",
            "Couldn't get this link data, try the other one": "Не удалось получить данные по ссылке, попробуйте другую",
            "Wrong response format from the server": "Неполадки на сервере",
          },
            "table" : {
            "With headings": "見出し付き",
            "Without headings": "見出し無し",
            "Add column to left": "左に追加",
            "Add column to right": "右に追加",
            "Delete column": "列の削除",
            "Add row above": "上の行を追加",
            "Add row below": "下の行を追加",
            "Delete row": "行の削除",
            },
          "header": {
            "Header": "Заголовок",
            "Heading 2": "見出し",
          },
          "paragraph": {
            "Enter something": "Введите текст"
          },
          "list": {
            "Ordered": "番号で",
            "Unordered": "中黒で",
          }
        },

              blockTunes:{
                "delete": {
                  "Delete": "ブロックの削除",
                  "Click to delete": "削除を実行する",

                },
                "With border": {
                  "With border": "枠線"
                },
                "moveUp": {
                  "Move up": "上の行へ"
                },
                "moveDown": {
                  "Move down": "下の行へ"
                },
                list: {
                  "Unordered": "中黒"
                },
                image: {
                    "With border": "枠線をつける",
                },

              },

            },
          },
          onReady: () => {
            this.isready = true;
          },
          onChange : () => {
            this.editor.save().then((outputData) => {
                this.editdata = outputData;
            }).catch((error) => {
                console.log('Saving failed: ', error)
            });
          }
        });
        const min_array = ["00","15","30","45"];
        for(let i=0 ; i < 24 ; i++)
        {
            for(let ci = 0 ; ci < min_array.length ; ci++)
                this.timetable.push(( '00' + i ).slice( -2 )+":"+ min_array[ci]);
        }
    }
}
</script>
